$component-class: 'me-tag';
$tag-font-size: map-get($font-sizes, md);
$tag-line-height: map-get($line-heights, md);
$tag-font-weight: map-get($font-weights, semi-bold);

.#{$component-class} {
  display: inline-flex;
  color: var(--text-color-primary);
  font-size: $tag-font-size;
  line-height: $tag-line-height;
  font-weight: $tag-font-weight;
  background-color: var(--background-color-secondary);
  border-radius: var(--radius-size-md);
  padding: var(--spacing-2xs) var(--spacing-xs);
  user-select: none;
  text-decoration: none;
}
